import { render, staticRenderFns } from "./index.vue?vue&type=template&id=204980bb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=204980bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204980bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/platform_beta/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204980bb')) {
      api.createRecord('204980bb', component.options)
    } else {
      api.reload('204980bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=204980bb&scoped=true&", function () {
      api.rerender('204980bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonTable/SubmitForm/index.vue"
export default component.exports